<template>
    <div class="login">
        <div class="container">
            <div class="row">
                <form @submit.prevent="loginAdmin()">
                    <div class="input-field col s12">
                        <input id="login" type="text" class="validate"
                               v-model="login"
                               :class="{invalid:($v.login.$dirty && !$v.login.required) || errors.password}" @input="errors.password=''">
                        <label for="login">Логин</label>
                    </div>
                    <div class="input-field col s12">
                        <input id="password" type="password" class="validate"
                               v-model="password"
                               :class="{invalid:($v.password.$dirty && !$v.password.required) || errors.password}" @input="errors.password=''">
                        <label for="password">Пароль</label>
                        <small class="helper-text invalid"
                               v-if="1">{{errors.password}}</small>
                    </div>
                    <button class="btn waves-effect waves-light orange darken-2" type="submit" name="action">Войти
                        <i class="material-icons right">send</i>
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import materialize from 'materialize-css/dist/js/materialize.min'
    import {required} from 'vuelidate/lib/validators'

    export default {
        name: "AdminLogin",
        data: () => ({
            login: '',
            password: '',
            errors: {}
        }),
        validations: {
            login: {required},
            password: {required},
        },
        mounted() {
            M.updateTextFields();
        },
        methods: {
            async loginAdmin() {
                if (this.$v.$invalid) {
                    this.$v.$touch();
                    return;
                }
                let data = new FormData;
                data.append('action', 'login');
                data.append('login', this.login);
                data.append('password', this.password);
                try {
                    let response = await fetch(this.$rootPath + '/backend/app/', {
                        method: 'POST',
                        body: data,
                    });
                    let responseData = await response.json();
                    if (!responseData.error && responseData.token) {
                        this.$cookie.set('token', responseData.token, 1);
                        this.$store.commit('confirmToken');
                        this.$router.push({path:'/admin/home'});
                    } else if (responseData.error) {
                        this.errors = responseData.errorsList;
                    }
                } catch (e) {
                    console.log(e);
                }
            },
        },
    }
</script>

<style scoped lang="scss">
    $color: #f57c00;
    .login {
        height: 100vh;

        @import "https://fonts.googleapis.com/icon?family=Material+Icons";
        @import "~materialize-css/sass/materialize";


        .container {
            height: 100%;

            .row {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            form {
                display: flex;
                flex-direction: column;
                width: 90%;
                max-width: 20rem;
                margin-bottom: 20vh;

                .input-field {
                    padding: 0;
                    small {
                        color: red;
                    }
                    input:focus + label {
                        color: $color;
                    }

                    input:focus {
                        border-bottom: 1px solid $color;
                        box-shadow: 0 1px 0 0 $color;
                    }
                }

                button {
                    i {
                        position: absolute;
                        right: 6%;
                    }
                }
            }
        }
    }
</style>